"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BotBonusUtils = void 0;
const react_1 = require("react");
const api_1 = require("./api");
const interface_1 = require("../interface/interface");
const rxjs_1 = require("rxjs");
const BonusResultStateFormat_1 = require("./BonusResultStateFormat");
var BotBonusUtils;
(function (BotBonusUtils) {
    BotBonusUtils.useBotBonus = (isActive) => {
        const [botBonusInfo, setBotBonusInfo] = (0, react_1.useState)({ loading: isActive === true });
        (0, react_1.useEffect)(() => {
            if (!isActive) {
                return;
            }
            const sub = api_1.BotBonusApi.requestUserBotBonus().subscribe({
                next: (data) => {
                    setBotBonusInfo({ data: data, loading: false });
                },
                error: (err) => {
                    setBotBonusInfo({ error: err, loading: false });
                },
            });
            return () => {
                sub.unsubscribe();
            };
        }, [isActive]);
        return botBonusInfo;
    };
    BotBonusUtils.collect = (bonusId) => {
        return api_1.BotBonusApi.collectBotBonus(bonusId);
    };
    BotBonusUtils.requestBotBonus = (bonusId) => {
        return api_1.BotBonusApi.requestBotBonus(bonusId);
    };
    /** 获取发财金使用记录 */
    BotBonusUtils.useBotBonusRecord = () => {
        const [data, setData] = (0, react_1.useState)();
        const [loading, setLoading] = (0, react_1.useState)(true);
        const [errorMsg, setErrorMsg] = (0, react_1.useState)();
        (0, react_1.useEffect)(() => {
            setLoading(true);
            const sub = api_1.BotBonusApi.requestBotBonusRecord().subscribe({
                next(value) {
                    setData(Array.isArray(value.results) ? value.results : []);
                    setErrorMsg(undefined);
                },
                error(err) {
                    setErrorMsg(err);
                    setLoading(false);
                },
                complete() {
                    setLoading(false);
                },
            });
            return () => {
                sub.unsubscribe();
            };
        }, []);
        return { data, loading, errorMsg };
    };
    /** 发财金活动状态检查 */
    BotBonusUtils.useBotBonusTaskState = ({ bonus_id }) => {
        const [loading, setLoading] = (0, react_1.useState)(true);
        const [errorMsg, setErrorMsg] = (0, react_1.useState)();
        const [data, setData] = (0, react_1.useState)();
        (0, react_1.useEffect)(() => {
            setLoading(true);
            const sub = api_1.BotBonusApi.checkBonusTaskState(bonus_id).subscribe({
                next(value) {
                    setErrorMsg(undefined);
                    setData(value);
                },
                error(err) {
                    setLoading(false);
                    setErrorMsg(err);
                },
                complete() {
                    setLoading(false);
                },
            });
            return () => {
                sub.unsubscribe();
            };
        }, []);
        return { loading, errorMsg, data };
    };
    const baseBonusTaskRegisterAndCollect = ({ task_id, $st }) => {
        return api_1.BotBonusApi.bonusTaskRegisterAndCollect(task_id).pipe((0, rxjs_1.map)((res) => {
            var _a, _b;
            const failedInfo = [
                (_a = res.failed_info) === null || _a === void 0 ? void 0 : _a.collect_fail_reason,
                (_b = res.failed_info) === null || _b === void 0 ? void 0 : _b.register_fail_reason,
            ]
                .filter((e) => !!e)
                .map((e) => e);
            const obj = {
                state: "failed",
                failedInfo: failedInfo,
            };
            if (res.bu_order_id) {
                // 已使用过当前发财金开单
                obj.text = $st("bonus_funds_activity_error_created");
                obj.order_id = res.bu_order_id;
                obj.btnType = BonusResultStateFormat_1.EBonusButtonType.gotoOrderDetails;
                obj.bonus_id = res.user_bonus_id;
                return obj;
            }
            else if (res.register_success && res.collect_success) {
                // 报名+领取成功
                obj.state = "success";
                obj.bonus_id = res.user_bonus_id;
                return obj;
            }
            else if (failedInfo.some((e) => e.startsWith("1006_error_region"))) {
                //区域不符合要求
                obj.text = $st("bonus_funds_activity_error_region_failed") + `\nError Code: ${failedInfo.join(",")}`;
            }
            else if (failedInfo.some((e) => e.startsWith("1007_not_enough"))) {
                // 用户不符合充值金额的要求
                obj.text = $st("bonus_funds_activity_error_deposit_not_enough") + `\nError Code: ${failedInfo.join(",")}`;
            }
            return obj;
        }));
    };
    const formatterErrorRemoteTranslation = (errorArr, $st) => {
        const remoteArr = errorArr
            .map((err) => {
            const errKey = `ERROR_DE_${err}`;
            const transErr = $st(errKey);
            if (transErr === errKey) {
                // 未解析的错误码
                return null;
            }
            else {
                // 解析到的错误吗
                return transErr;
            }
        })
            .filter((e) => !!e);
        return remoteArr.length ? remoteArr[0] : null;
    };
    /** 发财金报名+领取 用于简化敢赔单活动下单 */
    BotBonusUtils.bonusTaskRegisterAndCollect = ({ task_id, $st }) => {
        return baseBonusTaskRegisterAndCollect({ task_id, $st }).pipe(
        // 解析错误文案
        (0, rxjs_1.map)((res) => {
            var _a;
            // 成功或者已经解析则直接返回
            if (res.state === "success" || res.text) {
                return res;
            }
            const obj = Object.assign({}, res);
            const failedInfo = (_a = res === null || res === void 0 ? void 0 : res.failedInfo) !== null && _a !== void 0 ? _a : [];
            if (failedInfo.includes(interface_1.BotBonusFailReason.exist_not_used_bonus)) {
                // 存在其他发财金， 需要先把其他发财金使用掉
                obj.text = $st("bonus_funds_activity_error_bonus_exit");
                obj.btnType = BonusResultStateFormat_1.EBonusButtonType.bonusDetail;
                return obj;
            }
            else if (failedInfo.includes(interface_1.BotBonusFailReason.exist_not_collect_bonus)) {
                // 存在未领取的发财金
                obj.text = $st("bonus_claim_error_bonus_un_collect_content");
                return obj;
            }
            else if (failedInfo.includes(interface_1.BotBonusFailReason.need_kyc)) {
                // 需要kyc
                obj.text = $st("bonus_funds_activity_error_need_kyc");
                obj.btnType = BonusResultStateFormat_1.EBonusButtonType.gotoKycPage;
                return obj;
            }
            else if (failedInfo.includes(interface_1.BotBonusFailReason.need_deposit)) {
                // 需要入金
                obj.text = $st("bonus_funds_activity_error_deposit");
                obj.btnType = BonusResultStateFormat_1.EBonusButtonType.goToDeposit;
                return obj;
            }
            else if (failedInfo.includes(interface_1.BotBonusFailReason.in_black_regions)) {
                // 黑名单地区的用户
                obj.text = $st("bonus_funds_activity_error_account");
                return obj;
            }
            else if (failedInfo.includes(interface_1.BotBonusFailReason.only_invited)) {
                // 非该KOL邀请用户
                obj.text = $st("bonus_funds_activity_error_only_invited");
                return obj;
            }
            else if (failedInfo.includes(interface_1.BonusRegisterFailedReason.only_newly_user)) {
                // 非新用户
                obj.text = $st("bonus_funds_activity_error_only_newly_user");
                return obj;
            }
            else {
                const transErr = formatterErrorRemoteTranslation(failedInfo, $st);
                if (transErr) {
                    obj.text = transErr;
                }
                else {
                    obj.text = $st("bonus_funds_check_in_activity_error") + `\nError Code: ${failedInfo.join(",")}`;
                }
            }
            return obj;
        }));
    };
    /** 发财金签到 用于签到合约网格活动下单 */
    BotBonusUtils.bonusCheckInTaskRegisterAndCollect = ({ task_id, $st }) => {
        return baseBonusTaskRegisterAndCollect({ task_id, $st }).pipe(
        // 解析错误文案
        (0, rxjs_1.map)((res) => {
            var _a;
            // 成功或者已经解析则直接返回
            const obj = Object.assign({}, res);
            const failedInfo = (_a = res === null || res === void 0 ? void 0 : res.failedInfo) !== null && _a !== void 0 ? _a : [];
            if (obj.state === "success" || res.text) {
                return obj;
            }
            if (res.order_id) {
                // 已使用过当前发财金开单. 签到领发财金中, 已开过单认为状态是成功, 可以继续完成签到.
                obj.state = "success";
                return obj;
            }
            if (failedInfo.includes(interface_1.BotBonusFailReason.exist_not_used_bonus)) {
                // 存在其他发财金， 需要先把其他发财金使用掉
                obj.text = $st("bonus_funds_activity_check_in_error_bonus_exit");
                obj.btnType = BonusResultStateFormat_1.EBonusButtonType.bonusDetail;
                return obj;
            }
            else if (failedInfo.includes(interface_1.BotBonusFailReason.need_kyc)) {
                // 需要kyc
                obj.text = $st("bonus_funds_activity_check_in_error_need_kyc");
                obj.btnType = BonusResultStateFormat_1.EBonusButtonType.gotoKycPage;
                return obj;
            }
            else if (failedInfo.includes(interface_1.BotBonusFailReason.need_deposit)) {
                // 需要入金
                obj.text = $st("bonus_funds_activity_check_in_error_deposit");
                obj.btnType = BonusResultStateFormat_1.EBonusButtonType.goToDeposit;
                return obj;
            }
            else if (failedInfo.includes(interface_1.BotBonusFailReason.in_black_regions)) {
                // 黑名单地区的用户
                obj.text = $st("bonus_funds_activity_error_account");
                return obj;
            }
            else if (failedInfo.includes(interface_1.BotBonusFailReason.only_invited)) {
                // 非该KOL邀请用户
                obj.text = $st("bonus_funds_activity_error_only_invited");
                return obj;
            }
            else if (failedInfo.includes(interface_1.BonusRegisterFailedReason.only_newly_user)) {
                // 非新用户
                obj.text = $st("bonus_funds_activity_error_only_newly_user");
                return obj;
            }
            else {
                const transErr = formatterErrorRemoteTranslation(failedInfo, $st);
                if (transErr) {
                    obj.text = transErr;
                }
                else {
                    obj.text = $st("bonus_funds_check_in_activity_error") + `\nError Code: ${failedInfo.join(",")}`;
                }
                return obj;
            }
        }));
    };
    /** 发财金活动报名 */
    BotBonusUtils.bonusTaskRegister = (task_id) => {
        return api_1.BotBonusApi.bonusTaskRegister(task_id);
    };
    /** 发财金详情, 无需登录 */
    BotBonusUtils.bonusTaskDetail = (task_id) => {
        return api_1.BotBonusApi.bonusTaskDetail(task_id);
    };
    /** 发财金活动领取 */
    BotBonusUtils.bonusTaskClaim = (bonus_id) => {
        return api_1.BotBonusApi.bonusTaskClaim(bonus_id);
    };
    /** 发财金活动领取预检查 */
    BotBonusUtils.bonusTaskClaimCheck = (bonus_id) => {
        return api_1.BotBonusApi.checkBonusTaskState(bonus_id);
    };
    // 活动名称, 基于发财金的 support_type 进行映射
    let ActivityType;
    (function (ActivityType) {
        ActivityType["S8"] = "future_grid_competition_s8";
        ActivityType["DEFAULT"] = "";
    })(ActivityType = BotBonusUtils.ActivityType || (BotBonusUtils.ActivityType = {}));
    // 入金条件翻译转换
    BotBonusUtils.getBonusTaskConditionTypeI18n = BonusResultStateFormat_1.BonusResultStateFormat.getBonusTaskConditionTypeI18n;
    // 获取注册成功后 弹窗文案
    BotBonusUtils.getBonusRegisterSuccessTipsConfig = BonusResultStateFormat_1.BonusResultStateFormat.getBonusRegisterSuccessTipsConfig;
    // 获取注册失败后 弹窗文案
    BotBonusUtils.getBonusRegisterFailedTipsConfig = BonusResultStateFormat_1.BonusResultStateFormat.getBonusRegisterFailedTipsConfig;
    // 获取领取失败后 弹窗文案
    BotBonusUtils.getBonusClaimFailedTipsConfig = BonusResultStateFormat_1.BonusResultStateFormat.getBonusClaimFailedTipsConfig;
    // 领取成功文案
    BotBonusUtils.getBonusClaimSuccessTipsConfig = BonusResultStateFormat_1.BonusResultStateFormat.getBonusClaimSuccessTipsConfig;
    // 未登录提示
    BotBonusUtils.getBonusUnloginTipsConfig = BonusResultStateFormat_1.BonusResultStateFormat.getBonusUnloginTipsConfig;
})(BotBonusUtils || (exports.BotBonusUtils = BotBonusUtils = {}));
